<div class="coupon">
  <div class="left">
    <img [src]="iconPath" alt="icono del cupón" />
  </div>
  <div class="center">
    <div class="center-content">
      <div>
        <span style="font-weight: 800">{{ name }}</span>
        <span class="tooltip-wrapper">
          <img src="assets/images/icons/info.svg" alt="info icon" />
          <div class="tooltip-html" [innerHTML]="tooltipContent"></div>
        </span>
      </div>

      <div>
        <span
          style="max-width: 65%; font-size: small"
          [innerHTML]="expirationDate"
        ></span>
        <label class="switch" style="margin-bottom: 0em; margin-top: 10px">
          <input
            type="checkbox"
            [(ngModel)]="isEnabled"
            (change)="onToggleCoupon($event)"
          />
          <span class="slider"></span>
        </label>
      </div>
    </div>
  </div>

  <div class="right">
    <div class="right-content"></div>
  </div>
</div>
